
































































































































































































import { Component, Vue, Watch, PropSync, Ref } from "vue-property-decorator";
import { VeiculoModel } from "@/models/veiculo/VeiculoModel";
import { consultaVeiculoModule } from "@/store/consulta-veiculo/ConsultaVeiculo";
import { TIPOS_VEICULO } from "@/models/veiculo/TipoVeiculoModel";
import {
  extend,
  setInteractionMode,
  ValidationObserver,
  ValidationProvider,
} from "vee-validate";
import moment from "moment";
import {
  EstadosCidades,
  EstadosCidadesResponse,
} from "@/models/estados-cidades";
import axios from "axios";

extend("dataMenorQue", (value: any, params) => {
  const args = params as any[];
  if (args[0] != undefined) {
    return moment(value)
      .startOf("day")
      .isBefore(moment(`${args[0]}`).startOf("day"))
      ? "O campo {_field_} não pode ser menor que a Data de Fabricação"
      : true;
  } else {
    return true;
  }
});

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
  },
})
export default class ConsultaVeiculo extends Vue {
  @Ref("placaValidationProvider")
  placaValidationProvider!: InstanceType<typeof ValidationProvider>;
  @Ref("chassiValidationProvider")
  chassiValidationProvider!: InstanceType<typeof ValidationProvider>;

  veiculos = [] as VeiculoModel[];
 
  estados: EstadosCidades[] = [];
  cidades: string[] = [];
  estadoRegiaoFrota: EstadosCidades = {cidades: [], sigla: "", nome: ""};
  cidade: string = "";

  placa = "";
  veiculoDetail = "";
  chassi = "";
  showChassi = false;
  veiculoIndex = -1;
  tiposVeiculo = TIPOS_VEICULO;

  bloqueioMarca = false;
  bloqueioModelo = false;
  bloqueioAno = false;
  bloqueioAnoModelo = false;
  bloqueioCor = false;
  bloqueioTpVeiculo = false;
  bloqueioChassi = false;

  @PropSync("veiculo")
  veiculoSynced: VeiculoModel | undefined;

  @Watch("veiculoSynced")
  alterouVeiculo(val: VeiculoModel) {
    this.placa = val.placa;
    this.estadoRegiaoFrota = val.estadoRegiaoFrota;
  }

  cores = [
    { value: "PRETA", text: "Preta" },
    { value: "PRATA", text: "Prata" },
    { value: "BRANCA", text: "Branca" },
    { value: "CINZA", text: "Cinza" },
    { value: "AZUL", text: "Azul" },
    { value: "VERMELHO", text: "Vermelho" },
    { value: "VERDE", text: "Verde" },
    { value: "AMARELO", text: "Amarelo" },
    { value: "LARANJA", text: "Laranja" },
  ];

  @Watch("estadoRegiaoFrota")
  selectCities() {
    this.cidades = [];
    this.cidade = "";
    if (this.estadoRegiaoFrota) {
      this.cidades = this.estados.filter(
        (v) => v.sigla === this.estadoRegiaoFrota?.sigla
      )[0].cidades;

      this.veiculoSynced!.estadoRegiaoFrota = this.estadoRegiaoFrota;
    } else {
       this.estadoRegiaoFrota = {cidades: [], sigla: "", nome: ""};
    }
  }

  @Watch("placa", { immediate: true })
  observarPlaca() {
    this.veiculos = [];
    this.placa = this.placa.toUpperCase();
    if (this.placa.length > 6) {
      if (this.veiculos.length <= 0) {
        consultaVeiculoModule
          .obterDadosVeiculo(this.placa)
          .then((res: any) => {
            this.veiculos = consultaVeiculoModule.veiculos || [];
            if (this.veiculos.length <= 0) {
              this.veiculoDetail = "";
              const veiculo = this.veiculos[this.veiculoIndex] as VeiculoModel;
              this.bloquearCampos(veiculo);
              this.resetVeiculo();
            } else {
              for (let veiculo of this.veiculos) {
                  veiculo.placa = this.placa;
                  veiculo.estadoRegiaoFrota = this.estadoRegiaoFrota;
                  veiculo.cidadeRegiaoFrota = this.veiculoSynced?.cidadeRegiaoFrota;
                  
                  this.bloquearCampos(veiculo);

                  if (this.veiculoSynced && this.veiculoSynced.placa != this.placa) {
                    this.veiculoSynced = veiculo;                    
                  }
              }
            }
          })
          .catch((err: any) => {
            this.resetVeiculo();
          });
      }
    } else {
      this.veiculos = [];
    }
  }

  @Watch("chassi", { immediate: true })
  observarChassi() {
    this.chassi = this.chassi.toUpperCase();
    if (this.chassi.length > 16) {
      if (this.veiculos.length <= 0) {
        consultaVeiculoModule
          .obterDadosVeiculoChassi(this.chassi)
          .then((res: any) => {
            this.veiculos = consultaVeiculoModule.veiculos || [];
            if (this.veiculos.length <= 0) {
              this.chassiValidationProvider.setErrors([
                "Nenhum veículo encontrado para o chassi informado.",
              ]);
              this.placa = "";
              this.chassi = "";
            } else {
              const v = this.veiculos.find((v: VeiculoModel) => {
                return v.chassi == this.chassi;
              });
              this.veiculoIndex = v ? this.veiculos.indexOf(v) : -1;
            }
          })
          .catch((err: any) => {
            console.log(err);
            this.chassiValidationProvider.setErrors([
              "Nenhum veículo encontrado para o chassi informado.",
            ]);
            this.placa = "";
            this.chassi = "";
            this.resetVeiculo();
          });
      }
    } else {
      this.veiculos = [];
    }
  }

  mounted() {
    axios 
      .get<EstadosCidadesResponse>("/administrativo/json/estados-cidades.json") // /administrativo/json/estados-cidades.json
      .then((resp) => (this.estados = resp.data.estados));
  }

  resetVeiculo() {

    this.bloqueioMarca = false;
    this.bloqueioModelo = false;
    this.bloqueioAno = false;
    this.bloqueioAnoModelo = false;
    this.bloqueioCor = false;
    this.bloqueioTpVeiculo = false;
    this.bloqueioChassi = false;

    this.veiculoSynced = {
      placa: this.placa,
      marca: "",
      modelo: "",
      anoFabricacao: "",
      anoModelo: "",
      cor: "",
      combustivel: "",
      cilindrada: "",
      chassi: "",
    };
  }

  bloquearCampos(val : VeiculoModel) {
    
    this.bloqueioMarca = false;
    this.bloqueioModelo = false;
    this.bloqueioAno = false;
    this.bloqueioAnoModelo = false;
    this.bloqueioCor = false;
    this.bloqueioTpVeiculo = false;
    this.bloqueioChassi = false;

    if (val.marca) {
      this.bloqueioMarca = true;
    }
    if (val.anoModelo) {
      this.bloqueioAnoModelo = true;
    } 
    if (val.cor) {
      for (let i = 0; i < this.cores.length; i++) {
        if (this.cores[i].value == val.cor.toUpperCase()) {
            this.bloqueioCor = true;
        }
      } 
    }
    if (val.marca) {
      this.bloqueioMarca = true;
    } 
    if (val.modelo) {
      this.bloqueioModelo = true;
    } 
    if (val.anoFabricacao) {
      this.bloqueioAno = true;
    } 
    if (val.anoModelo) {
      this.bloqueioAnoModelo = true;
    }
    if (val.chassi) {
      this.bloqueioChassi = true;
    }
    if (val.tipoVeiculo?.descricao) {
      this.bloqueioTpVeiculo = true;
    }
  }  
}
